import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  showScreens = false;

  constructor() { }

  ngOnInit() {
  }

  toggleShowScreens() {
    this.showScreens = !this.showScreens;
  }
}
